import createEntityBundle from '~/src/Lib/createEntityBundle'
import { PackageAdjustmentReason as schema } from '~/src/Store/Schemas'

const name = 'packageAdjustmentReasons'

export default createEntityBundle({
  name,
  apiConfig: {
    schema,
  },
})
